import { Gutter } from '~/shared/components/Gutter';
import { MaxWidth } from '~/shared/components/MaxWidth';
import { useModule } from '../../hooks/useModule';
import { useModuleTheme } from '../../hooks/useModuleTheme';
import { StyledModule } from './styled';
import { ModuleContainerProps } from './types';

export type { ModuleContainerProps } from './types';

export const ModuleContainer = ({
    fullWidth,
    children,
    inputRef,
    spacingTop,
    spacingBottom = 'default',
    hasGutter,
    className,
    backgroundColor: initialBackgroundColor,
    id,
}: ModuleContainerProps) => {
    const { index } = useModule();
    const { backgroundColor } = useModuleTheme({ backgroundColor: initialBackgroundColor });
    const content = hasGutter ? <Gutter>{children}</Gutter> : children;

    return (
        <StyledModule
            id={id}
            className={className}
            backgroundColor={backgroundColor}
            ref={inputRef}
            spacingBottom={spacingBottom}
            spacingTop={spacingTop ? spacingTop : index === 0 ? 'small' : spacingBottom}
        >
            {fullWidth ? content : <MaxWidth>{content}</MaxWidth>}
        </StyledModule>
    );
};
